const routes = {
  auth: () => {
    const path = '/acesso/';

    return {
      login: `${path}/verificar-email`,
      access: `${path}/enviar-codigo`,
      code: `${path}/codigo`,
      terms: `${path}/termos`,
    };
  },

  intro: () => {
    const path = '/introducao/';

    return {
      welcome: `${path}/bem-vindo`,
      preferences: `${path}/preferencias`,
      completeProfile: `${path}/completar-perfil`,
    };
  },

  home: '/',

  meeting: (matchId?: number) => {
    const path = '/reunioes/';

    return {
      meeting: `${path}`,
      details: `${path}detalhes/${matchId}`,
    };
  },

  notSubscribed: '/nao-inscrito',

  termsOfUse: '/termos-de-uso',
  privacyPolicy: '/politica-de-privacidade',

  pdfGenerator: (type: string, filename: string, additional: string) =>
    `/api/pdf-generator?type=${type}&filename=${filename}${additional}`,
};

export default routes;
